import {IRunFile} from '../../incase-domain/proptypes/runfile';
import {RESET_RUNFILE, RunfileReducerType, UPDATE_PRESENTATION_RUN_FILE} from '../actions/types/runfile.actions.types';

export interface RunFileReducerState {
    runFile: IRunFile;
}

export const preloadedState: RunFileReducerState = {
    runFile: {
        slideDrawLines: [],
        elementInteractions: {},
        chalkboardUserComments: [],
        timeElapsed: 0,
    },
};

export const runFileReducer = (state: RunFileReducerState = preloadedState, action: RunfileReducerType): RunFileReducerState => {
    if (action.type === UPDATE_PRESENTATION_RUN_FILE && action.runFile) {
        return {...state, runFile: action.runFile};
    }
    if (action.type === RESET_RUNFILE) {
        return {...preloadedState};
    }
    return state;
};
